import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "row align-items-center py-4" }
const _hoisted_2 = { class: "col-lg-6 col-7" }
const _hoisted_3 = { class: "h2 text-white d-inline-block mb-0" }
const _hoisted_4 = {
  "aria-label": "breadcrumb",
  class: "d-none d-md-inline-block ml-md-4"
}
const _hoisted_5 = { class: "container-fluid mt--5" }
const _hoisted_6 = { class: "row justify-content-center px-xl-5 px-xxl-6 position-relative" }
const _hoisted_7 = { class: "col-xl-6 col-mb-12 p-0" }
const _hoisted_8 = { class: "col-xl-6 col-mb-12 p-0" }
const _hoisted_9 = { class: "row px-xl-5 px-xxl-6" }
const _hoisted_10 = { class: "col-lg-12 p-0 position-relative" }
const _hoisted_11 = {
  key: 0,
  class: "channels-list py-3 px-2"
}
const _hoisted_12 = { class: "font-weight-bold mr-1" }

import { onUnmounted, reactive, ref } from "vue";
import RouteBreadcrumb from "@/components/Breadcrumb/RouteBreadcrumb.vue";
import jwt from "jsonwebtoken";
import { AuthModule } from "@/store/modules/Auth";
import { Delete } from "@element-plus/icons-vue";
import { omniChannelClient } from "@/conection";
import { AlertModule } from "@/store/modules/Alert";
import { AxiosResponse } from "axios";
import { AppModule } from "@/store/modules/app";
import { computed, defineAsyncComponent } from "vue";
import BaseHeader from "@/components/BaseHeader.vue";
import callDataVue from "@/callcenter/components/callData.vue";
import { InterfacesColor, InterfaceId, InterfacesName } from "@/types/tickets";
import { Interfaces } from "@/types/tickets";
import userHistory from "@/callcenter/components/userHistory.vue";
import { CallDataModule } from "@/store/modules/CallData";
import { onMounted } from "vue";
import { env } from "@/config";
import { savedType } from "@/types/call";

type ChannelsByInterface = {
	[k: string]: {
		name: string;
		channels: { name: string; value: string }[];
	};
};

// => Computed

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const typification = defineAsyncComponent(() =>
	env.DynamicTypification
		? import(
				/* webpackChunckName: "typification" */ "@/callcenter/components/DynamicTypification.vue"
		  )
		: import(
				/* webpackChunckName: "typification" */ "@/callcenter/components/typification.vue"
		  )
);

// => Types
const user = computed(() => CallDataModule.user);
const channels = computed<ChannelsByInterface>(
	() =>
		user?.value?.channels?.reduce((acc: ChannelsByInterface, curr) => {
			const int: InterfaceId = curr?.channel?.interface as InterfaceId;
			if (acc[int]) {
				acc[int].channels.push({
					name: curr?.channel?.name ?? "canal",
					value: curr.service_id,
				});
			} else {
				acc[int] = {
					name: InterfacesName[int],
					channels: [
						{
							name: curr?.channel?.name ?? "canal",
							value:
								int === "WHATSAPP_PUP"
									? curr.service_id.split("@")[0]
									: curr.service_id,
						},
					],
				};
			}
			return acc;
		}, {} as ChannelsByInterface) ?? {}
);
// => Methods
/* onBeforeMount(() => {
	CallDataModule.updateActiveCall();
}); */
onMounted(() => {
	setTimeout(() => {
		CallDataModule.updateActiveCall({ type: savedType.meet });
	}, 1000);
});
onUnmounted(() => {
	CallDataModule.setActiveCall({
		call_number: "",
		uniqueid: "",
		userChanId: "",
		call_status: undefined,
		resultado: 0,
		call_type: "",
		queue: "",
		id: "",
	});
});
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// import { JitsiMeeting } from "@jitsi/vue-sdk";
// const meetingOptions = ref({
// 	domain: "172.16.11.246:8443",
// 	roomName: "MyCustomRoom",
// 	userInfo: {
// 		name: "John Doe",
// 		email: "john.doe@example.com",
// 	},
// 	configOverwrites: {
// 		startWithAudioMuted: true,
// 		startWithVideoMuted: true,
// 	},
// 	width: "80vw",
// 	height: "80vh"
//     // with:"100%",
//     // height:"100%"

// });

const catchMeet = async () => {
	try {
		const objectTosign = {
			context: {
				user: {
					avatar:
						AuthModule.user?.picture ?? AppModule.appConfig.meet_default_img,
					name: AuthModule.user?.name ?? AppModule.appConfig.meet_default_name,
				},
			},
			sub: env.meet_host_name,
			room: "MoLYTOnCHILAtiveR",
		};
		const response: AxiosResponse = await omniChannelClient({
			method: "post",
			url: "meet/ba/signJWT",
			data: objectTosign,
		});
		if (response?.status === 200) {
			window.open(
				env.meet_url + "/MoLYTOnCHILAtiveR" + "?jwt=" + response.data.newToken,
				"_blank"
			);
		} else {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `JWT: Autenticación fallida`,
				type: "warning",
			});
		}
	} catch (error) {
		console.error("error-->", error);
	}
};

const copylink = () => {
	const guestLink =
		env.meet_url + "/MoLYTOnCHILAtiveR" + "#config.prejoinConfig.enabled=false";
	console.log("URL PARA INVITADOS: ", guestLink);
	navigator.clipboard.writeText(guestLink);
};


return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BaseHeader, { class: "pb-6" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.$route.name), 1),
            _createElementVNode("nav", _hoisted_4, [
              _createVNode(RouteBreadcrumb)
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_card, { class: "no-border-card" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(callDataVue, { "is-meet-type": true })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_unref(typification), { "is-meet-type": true })
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (!_unref(env).onlyCallcenter && _unref(env).requiredCallcenter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(
									_unref(channels)
								), ([int, { name, channels: list }]) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: int,
                        class: "mx-1",
                        style: {"font-size":"1.1rem"}
                      }, [
                        _createVNode(_component_el_popover, {
                          trigger: "hover",
                          placement: "top",
                          title: name,
                          width: 300
                        }, {
                          reference: _withCtx(() => [
                            int
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: _normalizeClass(`${_unref(Interfaces)[int as InterfaceId]} text-${_unref(InterfacesColor)[int as InterfaceId]}`)
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (channel, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, [
                                  _createElementVNode("small", _hoisted_12, _toDisplayString(channel.name) + ": ", 1),
                                  _createElementVNode("small", null, _toDisplayString(channel.value), 1)
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 2
                        }, 1032, ["title"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createVNode(userHistory, { "is-meet-type": true })
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})